import { Injectable } from '@angular/core';
import { GestorInstanceModel } from '@app/data';
import { ApiService } from '@app/gateway';

/**
 * Assistente do Gestor por Conta: connects the Conta's own WhatsApp number (QR code) through dash-api.
 */
@Injectable({ providedIn: 'root' })
export class AssistenteGestorService {
  constructor(private readonly apiService: ApiService) {}

  /** Returns null when the Conta has no instance yet. */
  public async status(accountId: string): Promise<GestorInstanceModel | null> {
    const result = await this.call(async () => this.apiService.get<GestorInstanceModel | null>({ path: this.path(accountId, 'status') }));
    return result || null;
  }

  public async connect(accountId: string): Promise<GestorInstanceModel> {
    return this.call(async () => this.apiService.post<GestorInstanceModel>({ path: this.path(accountId, 'instance') }));
  }

  public async qrCode(accountId: string): Promise<GestorInstanceModel> {
    return this.call(async () => this.apiService.get<GestorInstanceModel>({ path: this.path(accountId, 'qrcode') }));
  }

  /** Returns null when there was no instance to disconnect. */
  public async logout(accountId: string): Promise<GestorInstanceModel | null> {
    const result = await this.call(async () => this.apiService.post<GestorInstanceModel | null>({ path: this.path(accountId, 'logout') }));
    return result || null;
  }

  private path(accountId: string, action: string): string {
    return `dash/assistente-gestor/${encodeURIComponent(accountId)}/${action}`;
  }

  private async call<T>(request: () => Promise<T>): Promise<T> {
    try {
      const result: T = await request();
      return result;
    } catch (error: unknown) {
      const message: string = error instanceof Error ? error.message : 'Não foi possível consultar o assistente do gestor agora.';
      throw new Error(message, { cause: error });
    }
  }
}
